import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import classNames from 'classnames';
import React from 'react';
import PropTypes from 'prop-types';
import { createBootstrapComponent } from './ThemeProvider';
import FormContext from './FormContext';
var propTypes = {
  /**
   * @default 'form-check-input'
   */
  bsPrefix: PropTypes.string,

  /**
   * @private
   */
  innerRef: PropTypes.any,

  /** The HTML for attribute for associating the label with an input */
  htmlFor: PropTypes.string
};
var defaultProps = {
  type: 'checkbox'
};

function FormCheckLabel(_ref) {
  var bsPrefix = _ref.bsPrefix,
      className = _ref.className,
      innerRef = _ref.innerRef,
      htmlFor = _ref.htmlFor,
      props = _objectWithoutPropertiesLoose(_ref, ["bsPrefix", "className", "innerRef", "htmlFor"]);

  return React.createElement(FormContext.Consumer, null, function (_ref2) {
    var controlId = _ref2.controlId;
    return React.createElement("label", _extends({}, props, {
      ref: innerRef,
      htmlFor: htmlFor || controlId,
      className: classNames(className, bsPrefix)
    }));
  });
}

FormCheckLabel.propTypes = propTypes;
FormCheckLabel.defaultProps = defaultProps;
export default createBootstrapComponent(FormCheckLabel, 'form-check-label');


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-bootstrap/es/FormCheckLabel.js
// module id = 644
// module chunks = 0